import { render } from "./AppSideNav.vue?vue&type=template&id=6f3d4aa0"
import script from "./AppSideNav.vue?vue&type=script&lang=js"
export * from "./AppSideNav.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__